import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router"

import ButtonComponent from "../../../../../Components/Button"
import InfoTooltip from "../../../../../Components/InfoTooltip/InfoTooltip"
import Images from "../../../../../Images"
import BrandTag from "../../../components/BrandTag/BrandTag"
import { ESTIMATED_STATUS_TOOLTIP } from "../../../components/Monitoring/monitoringCopy"
import PeriodLabel from "../../../components/Monitoring/PeriodLabel/PeriodLabel"
import EstimatedProgramStatusTable from "./Table/EstimatedProgramStatusTable"

import "./EstimatedProgramStatus.less"

const { Text } = Typography

const EstimatedProgramStatus = () => {
  const navigate = useNavigate()
  const { search } = useLocation()
  const { t } = useTranslation()
  const { isMobile } = useSelector((state) => state.nav)

  const handleViewAll = () => {
    navigate(`estimated_program_status${search}`)
  }

  return (
    <div className="estimated-program-status-wrap">
      <div className="estimated-program-status">
        <Flex className="header" align="flex-start" justify="space-between" gap={10}>
          <Flex align="center" gap={8}>
            <Text>Estimated program status</Text>
            <BrandTag label="Visa" image={Images.visa_3d} />
            <InfoTooltip title={ESTIMATED_STATUS_TOOLTIP} />
          </Flex>
          <Flex align="center" gap={12}>
            <PeriodLabel />
            {!isMobile && (
              <ButtonComponent onClick={handleViewAll}>{t("View All")}</ButtonComponent>
            )}
          </Flex>
        </Flex>

        <EstimatedProgramStatusTable variant="block" pageSize={5} />
      </div>

      {isMobile && (
        <ButtonComponent
          // className="estimated-program-status-view-all-btn"
          style={{ width: "100%", marginTop: 16, height: 40 }}
          onClick={handleViewAll}
        >
          {t("View All")}
        </ButtonComponent>
      )}
    </div>
  )
}

export default EstimatedProgramStatus
